<template>
  <div class="header-wrapper row m-0">
    <SearchBar />
    <Logo />
    <div class="left-header col-lg-7 col-md-7 col-8 p-0">
      <div class="header-notifications">
        <span v-if="role === 'Ukrainian Manager'" class="badge text-bg-danger">
          <router-link style="color: white;" :to="{ name: 'UkrainianChannels', query: { status: 'pending_check' } }">
            Creator approvals {{ pendingChannels }}
          </router-link>
        </span>
        <span v-else class="badge text-bg-danger">
          <router-link style="color: white;" :to="{ name: 'Channels', query: { status: 'pending_check' } }">
            Creator approvals {{ pendingChannels }}
          </router-link>
        </span>
        <span class="badge text-bg-info text-white">
          <router-link style="color: white;" :to="{ name: 'Payouts', query: { status: 'pending_confirmation' } }">
            Payout approvals {{ pendingPayouts }}
          </router-link>
        </span>
        <span class="badge text-bg-warning text-white">
          <router-link style="color: white;" :to="{ name: 'Posts', query: { status: 'pending', ai_moderation_status: ['flagged', 'rejected'] } }">
            Post approvals {{ pendingPosts }}
          </router-link>
        </span>
      </div>
    </div>
    <div class="nav-right col-lg-5 col-md-4 col-2 pull-right right-header p-0 ms-auto">
      <ul class="nav-menus">
        <Profile />
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Profile from './profile';
import Logo from './logo.vue';
import SearchBar from './search';
import axios from "axios";
import Notifications from "@/components/header/notifications.vue";
import store from "@/store";

export default {
  //   name: 'Search',
  components: {
    Notifications,
    Profile,
    Logo,
    SearchBar,
  },
  data() {
    return {
      bookmark: false,
      pendingChannels: 0,
      pendingPayouts: 0,
      pendingPosts: 0,
      notifications: 0,
      role: store.state.auth.user.role,
    };
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.searchData,
      megamenuItems: (state) => state.menu.megamenu,
      searchOpen: (state) => state.menu.searchOpen,
    }),
  },
  methods: {
    search_open() {
      this.$store.state.menu.searchOpen = true;
    },
    bookmark_open() {
      this.bookmark = !this.bookmark;
    },
    getPendingChannelCount() {
      const country = this.role === 'Ukrainian Manager' ? 'UA' : '';
      axios.get(`admin/channel/pending?country=${country}`)
        .then(response => {
          this.pendingChannels = response.data.pending_channels;
          if (this.pendingChannels > 0) {
            this.notifications++;
          }
        })
        .catch(error => {
          console.log(error);
        })
    },


    getPendingPayoutCount() {
      axios.get(`admin/payouts/pending`)
        .then(response => {
          this.pendingPayouts = response.data.pending_payouts;
          if (this.pendingPayouts > 0) {
            this.notifications++;
          }
        })
        .catch(error => {
          console.log(error);
        })
    },

    getPendingPostCount() {
      axios.get(`admin/posts/pending`)
        .then(response => {
          this.pendingPosts = response.data.pending_posts;
          console.log(this.pendingPosts);
          if (this.pendingPosts > 0) {
            this.notifications++;
          }
        })
        .catch(error => {
          console.log(error);
        })
    },

  },

  created() {
    window.addEventListener('pending-channel-count-changed', this.getPendingChannelCount);
    this.getPendingChannelCount();
    this.getPendingPayoutCount();
    this.getPendingPostCount();
  },
  beforeUnmount() {
    window.removeEventListener('pending-channel-count-changed', this.getPendingChannelCount);
  },
};
</script>
